import rootReducer from './rootReducer';
import tagsReducer from "./tagsSlice";
import { configureStore } from '@reduxjs/toolkit';

const middlewares = [];
const staticReducers = {
  tags: tagsReducer,  // static slice
};
const store = configureStore({
	reducer: rootReducer(staticReducers),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
})

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(rootReducer(store.asyncReducers));
	return store
}

export default store